<flash-messages></flash-messages>
<div class="attendee-header">
    <ccl-custom-page [model]="headerConfig.template.pages['landing']"></ccl-custom-page>
</div>
<div class="container-fluid">
    <div
        class="center-section row"
        [ngClass]="{ 'top-filter': sharedService.catalogLayoutConfig.filterPlacement == 'top' }"
    >
        <div
            [ngClass]="{
                'list-padding': true
            }"
        >
            <div class="attendee-html-top" *ngIf="htmlTopConfig.isEnabled">
                <ccl-custom-page [model]="htmlTopConfig.template.pages['landing']"></ccl-custom-page>
            </div>
            <div class="attendee-tabs"><tab-section></tab-section></div>

            <div class="active-filter-bar" *ngIf="sharedService.clearAllFilterEnabled">
                <div *ngFor="let filterKey of sharedService.objectKeys(sharedService.selectedFilterData)">
                    <div *ngIf="sharedService.selectedFilterData[filterKey] != null">
                        <div *ngFor="let filterObject of sharedService.filterData[filterKey]">
                            <div
                                *ngIf="sharedService.selectedFilterData[filterKey][filterObject.id] == true"
                                class="pull-left selected-filter-item"
                                [ngStyle]="{
                                    'border-color': filterConfig.header.backgroundColor
                                }"
                            >
                                <span *ngIf="filterKey != 'sessionDate'; else isDate">
                                    {{ filterObject.name }}{{ filterObject.label }}
                                </span>
                                <ng-template #isDate>{{ filterObject.label | date: tabConfig.dateFormat }}</ng-template>
                                <span title="Clear Filter"
                                    class="fa fa-close"
                                    (cclClick)="clearSingleFilter(filterKey, filterObject.id)"
                                ></span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="clearfix"></div>
            </div>
            <div class="session-list"><session-section></session-section></div>

            <div class="attendee-html-bottom" *ngIf="htmlBottomConfig.isEnabled">
                <ccl-custom-page [model]="htmlBottomConfig.template.pages['landing']"></ccl-custom-page>
            </div>
        </div>
    </div>
    <div class="speaker"></div>
</div>
<div class="attendee-footer"><ccl-custom-page [model]="footerConfig.template.pages['landing']"></ccl-custom-page></div>
